<template>
  <div class="information">
    <div class="pop-head">
      <h3 class="title">通知</h3>
      <svg-icon style="color: #72767b;font-size: 12px;font-weight: 400;cursor: pointer;" icon-class="close" @click="close()" />
    </div>
    <div class="popContent">
      <div class="tab">
        <el-tabs v-model="tabName">
          <el-tab-pane label="" name="common">
            <div slot="label">
              公共
              <span v-if="commonInfoCount">({{commonInfoCount}})</span>
            </div>
          </el-tab-pane>
          <el-tab-pane label="" name="personal">
            <div slot="label">
              个人
              <span v-if="personalInfoCount">({{personalInfoCount}})</span>
            </div>
          </el-tab-pane>
        </el-tabs>

        <el-tooltip class="item" effect="dark" content="历史通知" placement="left">
          <svg-icon style="font-size: 20px;cursor: pointer;" icon-class="messageHistory" @click="linkToMessageList"/>
        </el-tooltip>

      </div>

      <div style="text-align: right; padding: 0 30px;">
        <el-button type="text" @click="()=>getMessageCenterList()">刷新</el-button>
        <el-button v-if="dataList.length>0" type="text" @click="()=>confirmMessage()">全部已读</el-button>
      </div>


      <div v-if="dataList.length" class="information_box">
        <div v-for="(message,index) of dataList"
          :key="index"
          @click="e=>toMessageInvoker(message, e)"
          :class="{canActive: message.linkto}"
          class="message">
          <infoItem :message="message"/>
          <div class="txt-right">
            <el-button v-if="message.actionUrl==='/versions/index'" type="text" @click="viewDetail">
              版本详情
            </el-button>
            <el-button type="text" @click="confirmMessage([message.msgid])">
              已读
            </el-button>
          </div>
        </div>
      </div>
      <div v-else class="noMessage">
        {{error? "消息获取失败，请刷新消息列表。": "暂无通知"}}
      </div>

    </div>
  </div>
</template>
<script>
import infoItem from "./infoItem";
export default {
  name: 'Information',
  components: {
    infoItem,
  },
  data(){
    return {
      tabName: "common",
      error: false,
      dataList: [],
    }
  },
  computed: {
    messageList() {
      return this.$store.state.notify.messageList;
    },
    commonInfoCount(){
      return this.$store.state.notify.count.common;
    },
    personalInfoCount(){
      return this.$store.state.notify.count.personal;
    }
  },
  watch: {
    tabName: function(){
      this.filterMessage();
		this.getMessageCenterList();
    },
    messageList: function(){
      this.filterMessage();
    }
  },
  mounted(){
    this.filterMessage();
    this.getMessageCenterList();
  },
  methods: {
    close() {
      this.$emit("close");
    },
    getMessageCenterList(){
      this.$api.mssageCenterList()
      .then(res=>{
        if(res && res.errcode == 0){
          this.$store.dispatch("notify/setMessageList", res.data);
          this.error = false;
        }
      })
      .catch(err=>{
        this.$store.dispatch("notify/setMessageList", []);
        this.error = true;
      })
    },
    confirmMessage(messageIds){
      let confirmIdArr = [];
      if(messageIds) {
        confirmIdArr = messageIds;
      } else {
        let arr = [];
        for(let message of this.messageList) {
          if(message.sendType === this.tabName) {
            arr.push(message.msgid);
          }
        }
        confirmIdArr = arr;
      }
      this.$api.messageCenterBatchUpdate({
        data: confirmIdArr
      })
      .then(res=>{
        if(res && res.errcode == 0){
          this.$store.dispatch("notify/removeMessage", confirmIdArr);
        }
      })
    },
    // 跳转到消息详情页
    linkToMessageList() {
      this.$router.push("/messageCenter/index");
      this.close();
    },
    toMessageInvoker(message,e) {
      const { linkto, type } = message;
      if (e.target.nodeName === "A"
        || e.target.nodeName === "BUTTON"
        || (e.target.parentNode && e.target.parentNode.nodeName === "BUTTON")) {
        e.stopPropagation();
        return;
      }
      if (type.includes("ASSISTANT_")) {
        window.localStorage.setItem("c_p_assistant_home", message.payload);
      }
      if (linkto) this.$router.push(linkto);
    },
    filterMessage(){
      let _messageList = this.messageList.map(message=>{
        if (message.type === "report") {
           message.linkto = "/report/download";
        } 
        else if (message.type.includes("ASSISTANT_")) {
          let url = message.actionUrl.split("?")[0];
          let payload = message.actionUrl.split("?")[1];
          message.linkto = this.$store.getters["permission/getIframeMap"](url) + '?' + payload ;
          message.payload = payload;
        } 
        else {
          message.linkto = message.actionUrl;
        }
        return message;
      })
      if(this.tabName == "common"){
        this.dataList = _messageList.filter(message=>{
          return message.sendType == "common";
        })
      }else{
        this.dataList = _messageList.filter(message=>{
          return message.sendType == "personal";
        })
      }
    },
    viewDetail() {
      window.open('https://majorel.feishu.cn/docs/doccndcskpHUXqhj9uARenTNhLf','target');
    }
  }
}
</script>
<style lang="scss" scoped>

.information{
  width: 100%;
  ::v-deep .el-tabs{
    height: 40px;
  }
  ::v-deep .el-tabs__nav-wrap::after{
    height: 0px;
  }
  ::v-deep .el-tabs__active-bar{
    height: 0px;
  }
}
.pop-head{
  height: 50px;
  font-size: 18px;
  padding: 0 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: rgb(247, 247, 247);
}
.title{
  font-size: 18px;
  color: hsla(218, 100%, 60%, 1);
  text-align: left;
}

.popContent{
  // padding: 0 30px;
}

.tab{
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 30px;
}

.canActive{
  cursor: pointer;
  &:hover{
    background: hsla(220, 100%, 99%, 1);
  }
}

.message{
  padding: 0 20px;
}

.txt-right{
  text-align: right;
}
.noMessage{
  font-size: initial;
  padding-top: 30%;
  width: 100%;
  color: gray;
  text-align: center;
}

.information_box{
  width: 100%;
  height: calc(100vh - 126px);
  overflow: scroll;

}
.information_box::-webkit-scrollbar { width: 8px; }
// .information-item{
//   padding-top: 5px;
// }
// .information-item+.information-item{
//   margin-top: 10px;
//   border-top: 1px solid #eee;
// }
// .information-item:last-child{
//   padding-bottom:  30px;
// }

</style>